import React, { useEffect } from 'react';
import { MapControl } from '@vis.gl/react-google-maps';

import { AutocompleteCustom } from './autocomplete-custom';

export const CustomMapControl = ({
  controlPosition,
  onPlaceSelect
}) => {
  useEffect(() => {
    const applyStylesToParent = () => {
      const childElement = document.querySelector('.autocomplete-control');
      if (childElement) {
        const parentElement = childElement.parentElement;
        if (parentElement) {
          parentElement.style.width = '100%';
          parentElement.style.maxWidth = '100%';
        }
      }
    };

    // Apply styles on mount
    applyStylesToParent();

    // Observe DOM changes in case the parent is dynamically created
    const observer = new MutationObserver(applyStylesToParent);
    observer.observe(document.body, { childList: true, subtree: true });

    // Cleanup observer
    return () => observer.disconnect();
  }, []);

  return (
    <MapControl position={controlPosition} >
      <div className="autocomplete-control" style={{backgroundColor: 'white'}}>
          <AutocompleteCustom onPlaceSelect={onPlaceSelect} />
      </div>
    </MapControl>
  );
};